/*
 * File: Privacy.tsx
 * Project: a-a
 * File Created: Friday, 25th October 2024 4:19:24 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Friday, 25th October 2024 4:19:33 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2024 Mutual Mobile, Mutual Mobile
 */
import React from 'react';

const Privacy = () => {
  return <div>Privacy</div>;
};

export default Privacy;
